<template>
    <transition name="fade">
        <div id="background" @click.stop="removePopup">
            <div id="popup" :class="{ live: store.live }">
                <div id="close" :class="{ live: store.live }"></div>
                <p>We are now switching to {{ status }}.</p>
            </div>
        </div>
    </transition>
</template>

<script>
import { store } from "../store";

export default {
    name: "SwitchPopup",
    data() {
        return {
            store: store,
        };
    },
    computed: {
        status() {
            if (this.store.live) {
                return "live radio";
            } else {
                return "the archive";
            }
        },
    },
    methods: {
        removePopup() {
            this.store.showSwitchPopup = false;
        },
    },
};
</script>

<style scoped>
#background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    backdrop-filter: blur(30px);
    background-color: rgba(255, 255, 255, 0.4);
}
@-moz-document url-prefix() {
    #background {
        background-color: rgba(255, 255, 255, 0.9) !important;
    }
}

#popup {
    background-color: #f9f57d;
    position: fixed;
    top: 50%;
    left: 50%;
    padding: 6rem 20px;
    width: calc(100vw - 40px);
    height: calc(100vh - 12rem);
    transform: translate(-50%, -50%);
}
#popup.live {
    padding: 10rem 20px;
    height: calc(100vh - 20rem);
}
/* @media only screen and (min-width: 738px) { */
/*     #popup, */
/*     #popup.live { */
/*         width: 60vw; */
/*         height: auto; */
/*     } */
/* } */
/* @media only screen and (min-width: 1101px) { */
@media only screen and (min-width: 738px) {
    #popup,
    #popup.live {
        height: auto;
        width: 60vw;
        padding: 1rem 1.5rem;
    }
}
@media only screen and (min-width: 1101px) {
    #popup,
    #popup.live {
        width: 30vw;
    }
}
#close {
    position: absolute;
    right: 20px;
    top: 5rem;
    width: 13px;
    height: 15px;
    cursor: pointer;
}
#close.live {
    top: 9rem;
}
#close:before,
#close:after {
    position: absolute;
    left: 6px;
    content: " ";
    height: 17px;
    width: 1px;
    background-color: black;
}
#close:before {
    transform: rotate(45deg);
}
#close:after {
    transform: rotate(-45deg);
}
@media only screen and (min-width: 738px) {
    #close {
        display: none;
    }
}
p {
    text-align: center;
}

a {
    border: 1px solid black;
    padding: 0.65rem 1rem 0.85rem;
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    text-align: center;
}
a:hover {
    background-color: black;
    color: #fcfac4;
}

.fade-enter-active {
    transition: opacity 0.5s;
}
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
